exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".richtig {\n  background-color: green; }\n\n.falsch {\n  background-color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/ein-mal-eins/ein-mal-eins.component.scss
// module id = 140
// module chunks = 1